import { Login, Register, PasswordRecovery } from "../Component";

export default [
    {
        path: "/login",
        component: Login,
        name: "login",
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/register",
        component: Register,
        name: "register",
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: "/forgot-password",
        component: PasswordRecovery,
        name: "login.forgot.password",
        meta: {
            requiresAuth: false,
        },
    },
];
